export default "__VITE_ASSET__ced0114d__"